export default __webpack_public_path__ + "static/media/map.0c972b00.png";